import { supabase } from '../lib/supabase';

/**
 * Test database connection and table access
 * Run this in browser console: testDatabase()
 */
export const testDatabase = async () => {
  console.log('🔍 Testing database connection...\n');
  
  const results = {
    connection: false,
    tables: {},
    errors: []
  };

  try {
    // Test 1: Check Supabase connection
    console.log('1. Testing Supabase connection...');
    const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
    if (sessionError) {
      results.errors.push(`Session error: ${sessionError.message}`);
    } else {
      results.connection = true;
      console.log('✅ Supabase connection: OK');
      console.log('   User:', sessionData?.session?.user?.email || 'Not logged in');
    }

    // Test 2: Check user_profiles table
    console.log('\n2. Testing user_profiles table...');
    try {
      const { data, error } = await supabase
        .from('user_profiles')
        .select('count')
        .limit(1);
      
      if (error) {
        results.errors.push(`user_profiles error: ${error.message} (Code: ${error.code})`);
        results.tables.user_profiles = { exists: false, error: error.message };
        console.log('❌ user_profiles table:', error.message);
      } else {
        results.tables.user_profiles = { exists: true };
        console.log('✅ user_profiles table: OK');
      }
    } catch (err) {
      results.errors.push(`user_profiles exception: ${err.message}`);
      results.tables.user_profiles = { exists: false, error: err.message };
      console.log('❌ user_profiles table:', err.message);
    }

    // Test 3: Check user_wallet table
    console.log('\n3. Testing user_wallet table...');
    try {
      const { data, error } = await supabase
        .from('user_wallet')
        .select('count')
        .limit(1);
      
      if (error) {
        results.errors.push(`user_wallet error: ${error.message} (Code: ${error.code})`);
        results.tables.user_wallet = { exists: false, error: error.message };
        console.log('❌ user_wallet table:', error.message);
      } else {
        results.tables.user_wallet = { exists: true };
        console.log('✅ user_wallet table: OK');
      }
    } catch (err) {
      results.errors.push(`user_wallet exception: ${err.message}`);
      results.tables.user_wallet = { exists: false, error: err.message };
      console.log('❌ user_wallet table:', err.message);
    }

    // Test 4: Check email_subscriptions table
    console.log('\n4. Testing email_subscriptions table...');
    try {
      const { data, error } = await supabase
        .from('email_subscriptions')
        .select('count')
        .limit(1);
      
      if (error) {
        results.errors.push(`email_subscriptions error: ${error.message} (Code: ${error.code})`);
        results.tables.email_subscriptions = { exists: false, error: error.message };
        console.log('❌ email_subscriptions table:', error.message);
      } else {
        results.tables.email_subscriptions = { exists: true };
        console.log('✅ email_subscriptions table: OK');
      }
    } catch (err) {
      results.errors.push(`email_subscriptions exception: ${err.message}`);
      results.tables.email_subscriptions = { exists: false, error: err.message };
      console.log('❌ email_subscriptions table:', err.message);
    }

    // Summary
    console.log('\n📊 Summary:');
    console.log('Connection:', results.connection ? '✅ OK' : '❌ Failed');
    console.log('Tables:');
    Object.entries(results.tables).forEach(([table, status]) => {
      console.log(`  ${table}:`, status.exists ? '✅ OK' : `❌ ${status.error}`);
    });

    if (results.errors.length > 0) {
      console.log('\n⚠️ Errors:');
      results.errors.forEach((error, i) => {
        console.log(`  ${i + 1}. ${error}`);
      });
    }

    return results;
  } catch (err) {
    console.error('❌ Database test failed:', err);
    results.errors.push(`Test failed: ${err.message}`);
    return results;
  }
};

// Make it available globally for easy testing
if (typeof window !== 'undefined') {
  window.testDatabase = testDatabase;
}


